import type { ReactElement } from 'react';
import { TextField as MuiTextField, type TextFieldProps as MuiTextFieldProps } from '@mui/material';

export type TextFieldProps = MuiTextFieldProps & {
  InputProps?: Record<string, unknown> | undefined;
  inputProps?: Record<string, unknown> | undefined;
  InputLabelProps?: Record<string, unknown> | undefined;
};

export function TextField({
  InputProps,
  inputProps,
  InputLabelProps,
  slotProps,
  ...props
}: TextFieldProps): ReactElement {
  const compatibleProps = {
    ...props,
    slotProps: {
      ...slotProps,
      input: InputProps,
      htmlInput: inputProps,
      inputLabel: InputLabelProps,
    },
  } as unknown as MuiTextFieldProps;
  return <MuiTextField {...compatibleProps} />;
}
